import { Invoice } from '../../models/invoice';
import { CreditCard } from '../../models/credit-card';
import { ServerMessage } from '../../models/server-message';
import { AppState } from '../index';
import { createSelector } from '@ngrx/store';

export interface PaymentState {
    payableInvoices: Invoice[];
    creditCards: CreditCard[];
    newCreditCard: CreditCard;
    selectedCardId?: string;
    selectedInvoiceIds: string[];
    paymentAmount: number;
    processing: boolean;
    loadingInvoices: boolean;
    loadingCards: boolean;
    message?: ServerMessage;
}

export const selectPaymentState = (state: AppState) => state.payment;

export const selectPaymentPayableInvoices = createSelector(selectPaymentState,
    (state: PaymentState) => state.payableInvoices);

export const selectPaymentCreditCards = createSelector(selectPaymentState,
    (state: PaymentState) => state.creditCards);

export const selectPaymentBusy = createSelector(selectPaymentState,
    (state: PaymentState) => state.processing || state.loadingInvoices || state.loadingCards);

export const selectPaymentSelectedInvoiceIds = createSelector(selectPaymentState,
    (state: PaymentState) => state.selectedInvoiceIds);

export const selectPaymentAmount = createSelector(selectPaymentState,
    (state: PaymentState) => state.payableInvoices
        .filter(i => state.selectedInvoiceIds.indexOf(i.id) > -1)
        .reduce((amount, invoice) => amount + invoice.outstanding, 0));

export const selectPaymentSelectedInvoices = createSelector(selectPaymentState,
    (state: PaymentState) => state.payableInvoices.filter(i => state.selectedInvoiceIds.indexOf(i.id) > -1));
